import { decodeHTML } from "entities";

const replaceNumericEntities = (
  value: string,
  replacer: (entity: string) => string,
) => value.replace(/&#(?:[xX][0-9a-fA-F]+|\d+);?/g, replacer);

const getNumericEntityCodePoint = (entity: string) => {
  const isHex = entity[2]?.toLowerCase() === "x";
  const start = isHex ? 3 : 2;
  const numericValue = entity.endsWith(";")
    ? entity.slice(start, -1)
    : entity.slice(start);
  return Number.parseInt(numericValue, isHex ? 16 : 10);
};

const isValidUnicodeScalarValue = (codePoint: number) =>
  Number.isInteger(codePoint) &&
  codePoint > 0 &&
  codePoint <= 0x10ffff &&
  (codePoint < 0xd800 || codePoint > 0xdfff);

export const protectInvalidNumericEntities = (value: string) =>
  replaceNumericEntities(value, (entity) => {
    const codePoint = getNumericEntityCodePoint(entity);
    if (isValidUnicodeScalarValue(codePoint)) return entity;

    return `&amp;${entity.slice(1)}`;
  });

export const decodeHtmlEntities = (value: string) => {
  if (!value) return "";
  return decodeHTML(protectInvalidNumericEntities(value));
};
